function CancellaAccount() {
  return (
    <html style={{ margin: "auto", width: "calc(100% - 20px)", maxWidth: 700 }}>
      <head>
        <title>La Braseria App - Istruzioni per cancellare l'account</title>
      </head>
      <body>
        <h1>La Braseria App - Istruzioni per cancellare l'account</h1>
        <p>
          Benvenuto nella pagina dedicata alle istruzioni per cancellare il tuo
          account su La Braseria App. Segui i passaggi di seguito per eliminare
          definitivamente il tuo profilo:
        </p>

        <ol>
          <li>Apri l'app La Braseria sul tuo dispositivo mobile.</li>
          <li>
            Accedi al tuo account utilizzando le tue credenziali di accesso
            (nome utente/e-mail e password).
          </li>
        </ol>

        <h2>Schermata iniziale:</h2>
        <p>
          Una volta effettuato l'accesso, sarai sulla schermata iniziale
          dell'app. Qui troverai diverse opzioni e impostazioni disponibili.
        </p>

        <ol start="3">
          <li>Clicca sull'opzione "Account":</li>
        </ol>

        <p>
          Sulla schermata iniziale, individua e tocca l'opzione "Account". Di
          solito, puoi trovarla nell'angolo superiore o inferiore dello schermo,
          a seconda del layout dell'app.
        </p>

        <ol start="4">
          <li>Seleziona "Elimina Profilo":</li>
        </ol>

        <p>
          Nella pagina "Account", scorri verso il basso fino a trovare l'opzione
          "Elimina Profilo" o "Cancella Account". Tocca questa opzione per
          procedere con la cancellazione del tuo account.
        </p>

        <ol start="5">
          <li>Conferma l'eliminazione:</li>
        </ol>

        <p>
          Dopo aver selezionato "Elimina Profilo", l'app potrebbe richiederti di
          confermare la tua scelta. Potresti ricevere un avviso che ti informa
          delle conseguenze irreversible dell'eliminazione del tuo account.
          Leggi attentamente le informazioni fornite e, se sei sicuro di voler
          procedere, conferma l'eliminazione seguendo le istruzioni fornite.
        </p>

        <h3>Fatto!</h3>

        <p>
          Una volta completate le istruzioni di conferma, il tuo account su La
          Braseria App sarà eliminato definitivamente. Tieni presente che non
          sarà possibile recuperare il tuo account dopo questa operazione, e
          perderai tutti i dati associati ad esso.
        </p>

        <p>
          Se hai bisogno di ulteriori assistenza o incontri problemi durante il
          processo di cancellazione dell'account, ti consigliamo di contattare
          il supporto clienti di La Braseria App per ottenere aiuto
          personalizzato.
        </p>

        <p>
          Ti ringraziamo per aver utilizzato La Braseria App e ci dispiace che
          tu abbia deciso di cancellare il tuo account. Speriamo di averti
          fornito un'esperienza positiva e ti auguriamo il meglio per il futuro.
        </p>
      </body>
    </html>
  );
}

export default CancellaAccount;
